<template>
    <div class="filter-products__item filter-select" v-click-outside="hide"
        :class="[{'filter-select--open': show, 'filter-select--selected': selected}, title]">
        <div
            class="filter-select__title"
            @click="toggle">
            <span v-if="title == 'brand'">Marka</span>
            <span v-else-if="title == 'labels'">Pokaż</span>
            <span v-else>{{title | capitalize | removeDash}}</span>
            <span v-if="selected">({{ selected }})</span>
            <svg width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L4.5 4.5L8 1" stroke="#494D49" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </div>
        <transition name="fade">
            <div class="filter-select__toggle" ref="toggleMenu" v-if="this.show && this.items"
                :class="{'filter-select__toggle--right': rightPosition}">
                <vue-custom-scrollbar class="scroll-area" :settings="settings">
                  <label class="filter-select__item" v-for="item in items" :key="item.title">
                      <input type="checkbox" :checked="item.selected" v-model="item.selected" :value="item.title" @change="selectedFilter" class="filter-select__checkbox">
                      <span class="filter-select__text" v-if="item.name == 'promo'">Promocje ({{item.value}})</span>
                      <span class="filter-select__text" v-else-if="item.name == 'new'">Nowości ({{item.value}})</span>
                      <span class="filter-select__text" v-else-if="item.name == 'sale'">Wyprzedaże ({{item.value}})</span>
                      <span class="filter-select__text" v-else>{{ item.name | removeDash }} ({{item.value}})</span>
                  </label>
                </vue-custom-scrollbar>
            </div>
        </transition>
    </div>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar'
export default {
  name: 'FilterItem',
  components: {
    vueCustomScrollbar
  },
  props: {
    title: undefined,
    items: undefined
  },
  data: function () {
    return {
      show: false,
      selected: undefined,
      count: 1,
      rightPosition: false,
      settings: {
        wheelPropagation: false
      }
    }
  },
  created: function () {
    this.countSelected()
    // Jeżeli nie ma określonej liczby produktów dodawaj 0
    this.items.forEach(item => {
      if (item.value === undefined) {
        item.value = 0
      }
    })
  },
  methods: {
    toggle: function () {
      this.show = !this.show
      this.rightPosition = false
      setTimeout(() => {
        this.checkPosition()
      }, 50)
    },
    hide: function () {
      this.show = false
    },
    selectedFilter: function () {
      this.countSelected()
      this.$emit('changeInput', true)
    },
    countSelected: function () {
      let itemsSelected = this.items.filter((item) => {
        return item.selected === true
      })
      this.selected = itemsSelected.length
    },
    checkPosition: function () {
      if (this.$refs.toggleMenu) {
        let menu = this.$refs.toggleMenu
        let postionX = menu.getBoundingClientRect().right
        let windowWidth = window.innerWidth - 20
        if (postionX > windowWidth) {
          this.rightPosition = true
        } else {
          this.rightPosition = false
        }
      }
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString().toLowerCase()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    removeDash: function (value) {
      if (!value) return ''
      value = value.split('_').join(' ')
      return value
    }

  },
  directives: {
    'click-outside': {
      bind: function (el, binding, vNode) {
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
          if (compName) { warn += `Found in component '${compName}'` }
          // eslint-disable-next-line
          console.warn(warn)
        }
        const bubble = binding.modifiers.bubble
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        document.addEventListener('click', handler)
      },

      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.filter-select {
    border: 1px solid #A1A1A1;
    box-sizing: border-box;
    border-radius: 4px;
    font-size: 12px;
    position: relative;
    &--open {
        border-radius: 4px 4px 0 0;
        border-bottom-color: #FFF;
        .filter-select {
            &__title {
                background: #FFF;
                z-index: 11;
                border-radius: 4px 4px 0 0;
            }
        }
    }
    &--selected {
        border-color: #8AB82D;
        border-width: 2px;
        .filter-select {
            &__toggle {
                border-color: #8AB82D;
                border-width: 2px;
                left: -2px;
                margin-top: -2px;
                min-width: calc(100% + 4px);
                &--right {
                    left: auto;
                    right: -2px;
                }
            }
        }
    }
    .scroll-area {
      position: relative;
      margin: auto;
      max-height: 225px;
      padding-right: 12px;
    }
    &__title {
        padding: 5px 36px 4px 12px;
        cursor: pointer;
        position: relative;
        svg {
            position: absolute;
            right: 14px;
            top: 50%;
            transform: translateY(-50%);
            fill: none
        }
    }
    &__toggle {
        border: 1px solid #A1A1A1;
        box-shadow: 0 0 10px rgba(0,0,0,0.01);
        position: absolute;
        top: 100%;
        left: -1px;
        min-width: calc(100% + 2px);
        z-index: 10;
        margin-top: -1px;
        padding: 4px 3px 4px 12px;
        background: #FFF;
        border-radius: 0 0 4px 4px;
        white-space: nowrap;
        overflow: hidden;
        max-height: 235px;
        &--right {
            left: auto;
            right: -1px;
            white-space: normal;
        }
    }
    &__item {
        margin: 8px 0;
        display: block;
        input {
            opacity: 0;
            position: absolute;
            &:checked + span {
                &::after {
                    background: #8AB82D;
                }
            }
        }
        span {
            display: block;
            position: relative;
            padding: 5px 0 3px 25px;
            line-height: 20px;
            cursor: pointer;
            color: #000;
            white-space: nowrap;
            &::after {
                position: absolute;
                border: 2px solid #8AB82D;
                border-radius: 3px;
                content: "";
                width: 15px;
                height: 15px;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
}
.manufacturer .filter-select.brand {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Algolia/components/filter-item.vue